import './ListInspection.style.less'
import {
  Avatar,
  Button,
  Col,
  DatePicker,
  Dropdown,
  Input,
  Row,
  Space,
  Table,
  Typography,
} from 'antd'
import {
  concat,
  debounce,
  find,
  get,
  includes,
  isEmpty,
  isString,
  lowerCase,
  noop,
  omitBy,
  pick,
  size,
  startCase,
  toNumber,
} from 'lodash'
import { useEffect, useState } from 'react'
import {
  DeleteOutlined,
  EditOutlined,
  FilePdfOutlined,
  FilterFilled,
  MoreOutlined,
  PlusOutlined,
  RetweetOutlined,
  UndoOutlined,
  UserOutlined,
} from '@ant-design/icons'
import ModalNewInspection from './components/ModalNewInspection/ModalNewInspection'
import MultiValueOverflow from './components/MultiValueOverflow/MultiValueOverflow'
import { useAtom } from 'jotai'
import { useMutation, useQuery } from 'react-query'

import {
  deleteApprovedInspection,
  deleteInspection,
  getAllInspectors,
  getFactoriesRef,
  getCountryByFactory,
  getSupplierRef,
} from '../Inspection.service'
import moment, { Moment } from 'moment'
import type { ColumnsType } from 'antd/es/table'
import type { MenuProps, TablePaginationConfig } from 'antd'
import {
  INSPECTION_PARAMS_TYPE,
  INSPECTION_PAYLOAD_TYPE,
  InspectionGroupStatus,
  InspectionResult,
  InspectionStatus,
  INSPECTION_ADVANCE_FILTER_LISTING,
  QSF_QUERY_KEY,
} from '@/constant/qsf'
import { activeTileInspectionAtom } from '@/jotai/qsf.jotai'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '@/providers/auth.provider'
import ModalReInspection from './components/ModalReInspection/ModalReInspection'
import {
  dateRangConverter,
  getUrlParams,
  handleAdvanceFilterQueryParams,
  isEmptyValue,
  setUrlParams,
  transformFromUrlQueryToDateRange,
} from '@/utils/common'
import ModalEditReInspection from './components/ModalEditReInspection/ModalEditReInspection'
import {
  isInspectionCreator,
  isInspectionInspector,
} from '@/screens/Order/Pages/EditOrder/EditOrder.helper'
import ModalConfirm from '@/components/ModalConfirm/ModalConfirm'
import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import { queryClient } from '@/config/react-query'
import {
  InspectionConstant,
  INSPECTION_TEXT,
  getLocalInpspectionPageSize,
  INSPECTION_PERMISSION,
  storeLocalInspectionPageSize,
} from '../Inspection.constant'
import {
  useGetPropertiesHook,
  useInspectionHook,
  useInspectionSummary,
  useOverallResultSettingHook,
} from '../Inspection.hook'
import {
  COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW,
  USER_ROLE,
} from '@/constant/user'
import {
  getCompanySettingRef,
  getInspectorSetting,
  getSupplierCanCreateInspectionSetting,
} from '@/screens/SystemConfigure/UserManagment/UserManagment.service'
import DrawerAdvanceFilter from './components/DrawerAdvanceFilter/index'
import {
  defaultInspectionFilter,
  useAdvanceSelectedOrderItem,
} from '@/jotai/inspection.jotai'
import { IsAdminRole, isInspectorRole, IsSupplierRole } from '@/utils/users'
import {
  getPropertyValueInspectionBrand,
  getPropertyValueInspectionType,
} from '@/screens/SystemConfigure/DataManagment/DataManagement.transform'
import { deleteFeatureEnabled } from '../../InspectionReport/InspectionReport.util'

const filterIcon = <FilterFilled style={{ fontSize: '19px' }} />
const undoIcon = <UndoOutlined style={{ fontSize: '19px' }} />

const { CREATE_EDIT } = INSPECTION_PERMISSION
const {
  REVIEWED,
  SUBMITTED,
  TO_PLAN,
  PLANNED,
  IN_PROGRESS,
  APPROVED,
  UNDER_REVIEW,
  NEEDS_REVISIONS,
} = InspectionStatus
const { ALL, ACTIVE, COMPLETED } = InspectionGroupStatus

const { Paragraph } = Typography

export default function InspectionList() {
  const navigation = useNavigate()
  const { user } = useAuth()
  const isInspRole = isInspectorRole(user)
  const isAdmin = IsAdminRole(user)
  const isSupplierRole = IsSupplierRole(user)
  const userRole = user?.subscription?.role_access?.role

  const { resetAtomSelectedOrders } = useAdvanceSelectedOrderItem()

  const cachePageSize = getLocalInpspectionPageSize()

  const [activeTile]: any = useAtom(activeTileInspectionAtom)
  const [openNewInspection, setOpenNewInspection] = useState(false)
  const [reInspectionModal, setReInspectionModal] = useState(false)
  const [editReInspectionModal, setEditReInspectionModal] = useState(false)
  const [inspection, setInspection] = useState(null)
  const [tmpSearch, setTmpSearch] = useState(getUrlParams('query'))
  const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)

  const [stateFilter, setStateFilter] = useState<INSPECTION_PAYLOAD_TYPE>({})
  const [stateParams, setStateParams] = useState<INSPECTION_PARAMS_TYPE>({
    page_size: cachePageSize,
    page_number: toNumber(getUrlParams('pageNumber')) || 1,
    group: getUrlParams('group'),
  })

  const { data: overallResultSettingData } = useOverallResultSettingHook()
  const overallResultSetting: any[] =
    (overallResultSettingData as any)?.options ?? []

  const [datesFilter, setDatesFilter] = useState<[Moment, Moment] | []>()
  const [submitDateFilter, setSubmitDateFilter] = useState<
    [Moment, Moment] | []
  >()

  const { data: inspectors } = useQuery('GET_INSPECTORS', getAllInspectors, {
    select: (data) => {
      return [
        ...data.map((inspector) => ({
          ...inspector,
          value: inspector.id,
          text: `${inspector?.first_name} ${inspector?.last_name}`,
        })),
        { text: '-', value: '', first_name: '-' },
      ]
    },
    enabled: userRole === USER_ROLE.ADMIN,
  })

  const [modalInspectionData, setModalInspectionData] = useState(null)
  const [stateSubmitForReview, setStateSubmitForReview] = useState(null)
  const [countryFactory, setCountryFactory] = useState(null)
  const [inspectionType, setInspectionType] = useState(null)
  const [inspectionBrand, setInspectionBrand] = useState(null)

  const [modalDelete, setModalDelete] = useState(false)
  const [enableEditRecord, setEnableEditRecord] = useState(
    includes(CREATE_EDIT, userRole)
  ) // CHECK IS ADMIN | INSPECTOR
  const [filterOptionsStatus, setFilterOptionsStatus] = useState([])

  const extraFilterOptionsBy = {
    [`${COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW}`]: {
      key: [ALL, COMPLETED],
      value: [
        { text: 'Under Review', value: UNDER_REVIEW },
        { text: 'Needs Revisions', value: NEEDS_REVISIONS },
      ],
    },
  }

  const filterOptionsForAll = [
    { text: 'To Plan', value: TO_PLAN },
    { text: 'Planned', value: PLANNED },
    { text: 'In Progress', value: IN_PROGRESS },
    { text: 'Submitted', value: SUBMITTED },
    { text: 'Approved', value: APPROVED },
  ]

  const filterOptionsForActive = [
    { text: 'To Plan', value: TO_PLAN },
    { text: 'Planned', value: PLANNED },
    { text: 'In Progress', value: IN_PROGRESS },
  ]

  const filterOptionsForSubmitted = [
    { text: 'Submitted', value: SUBMITTED },
    { text: 'Approved', value: APPROVED },
  ]

  const filterOptionsResult = [
    ...(overallResultSetting ?? []).map((item: any) => ({
      text: String(item.value ?? item.name ?? '').toUpperCase(),
      value: item.value,
    })),
    { text: '-', value: '' },
  ]
  const isEmptyFiltering = !size(omitBy(stateFilter, isEmpty))

  const {
    data: propertiesData,
    isFetched: isFetchedProperties,
    isLoading: isLoadingProperties,
  } = useGetPropertiesHook(['styleId', 'aql'])

  const styleIdsOptions =
    propertiesData?.find((item: any) => item.name === 'styleId')
      ?.property_values ?? []

  const {
    data: queryInspections,
    isFetching,
    isLoading,
    refetch,
    isFetched,
  } = useInspectionHook(stateParams, stateFilter)

  useInspectionSummary(stateFilter, { enabled: isFetched })

  const deleteMutation = useMutation(async () => {
    const isApproved = inspection?.status === APPROVED
    if (isApproved) {
      await deleteApprovedInspection(inspection.id)
    } else {
      await deleteInspection(inspection.id)
    }
  })

  const handleResetFilter = () => {
    handleTableChange({}, defaultInspectionFilter)
    resetAtomSelectedOrders()
  }

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: INSPECTION_PAYLOAD_TYPE
  ) => {
    const { current = 1 } = pagination

    const [strPlannedDate, momentPlannedDate] = dateRangConverter(
      filters?.planned_date
    )
    const [strSubmittedDate, momentSubmittedDate] = dateRangConverter(
      filters?.submitted_date
    )
    filters.planned_date = strPlannedDate
    filters.submitted_date = strSubmittedDate

    setDatesFilter(momentPlannedDate)
    setSubmitDateFilter(momentSubmittedDate)
    handleAdvanceFilterQueryParams(filters, {
      queriesAccepted: INSPECTION_ADVANCE_FILTER_LISTING,
      navigate,
    })
    onSetPage(current)
    handleSetStateFilters(filters)
  }

  const handleSetStateFilters = (newState: any) => {
    setStateFilter((preState) => ({ ...preState, ...newState }))
  }

  const handleSetStateParams = (newState: any) => {
    setStateParams((preState) => ({ ...preState, ...newState }))
  }

  const handleCheckPermission = (user: any, record: any) => {
    const isAdmin = IsAdminRole(user)
    const isInspInspector = isInspectionInspector(user, record)
    const isCreator = isInspectionCreator(user, record)
    return (
      isAdmin ||
      (enableEditRecord && isInspRole && isInspInspector && isCreator) ||
      (enableEditRecord && isSupplierRole && isCreator)
    )
  }
  const WIDTH = 180

  const handleStatusToReCreate = (reportStatus = '') => {
    let result = false

    if (includes([SUBMITTED, APPROVED], reportStatus)) {
      result = true
    }
    return result
  }

  const handleStatusToReviewReport = (reportStatus = '') => {
    let result = false
    if (
      includes(
        [REVIEWED, SUBMITTED, APPROVED, UNDER_REVIEW, NEEDS_REVISIONS],
        reportStatus
      )
    ) {
      result = true
    }
    return result
  }

  const columns: ColumnsType<any> = [
    {
      title: 'INSPECTION NO.',
      dataIndex: 'number',
      key: 'number',
      fixed: 'left',

      render: (value, record) => (
        <Row align="middle">
          <img
            alt="logo"
            src={
              record.orders[0]?.picture?.url_path ||
              require('../../../../assets/images/place-holder.jpg')
            }
            style={{
              borderRadius: '10px',
              backgroundColor: 'white',
              width: '55px',
              height: '55px',
              marginRight: '16px',
            }}
          />
          <Link
            to={
              ['SUBMITTED', 'APPROVED', UNDER_REVIEW, NEEDS_REVISIONS].includes(
                record?.status
              )
                ? `/qsf/report/${record.id}`
                : null
            }
            className={`landing-page-orderNo ${
              ['SUBMITTED', 'APPROVED', UNDER_REVIEW, NEEDS_REVISIONS].includes(
                record?.status
              ) && 'inspection-no-click-report'
            }`}
            style={{
              color: [
                'SUBMITTED',
                'APPROVED',
                UNDER_REVIEW,
                NEEDS_REVISIONS,
              ].includes(record?.status)
                ? ''
                : '#848484',
              cursor: [
                'SUBMITTED',
                'APPROVED',
                UNDER_REVIEW,
                NEEDS_REVISIONS,
              ].includes(record?.status)
                ? 'pointer'
                : 'unset',
            }}
          >
            {value}
            {record?.is_re_inspection && <span className="re-tag">RE</span>}
          </Link>
        </Row>
      ),
    },
    {
      title: 'TYPE',
      dataIndex: 'inspection_type_name',
      key: 'inspection_type_name',
      render: (_, record) => (
        <Paragraph style={{ margin: 0 }}>
          {record?.inspection_type_name ?? ''}
        </Paragraph>
      ),
    },

    {
      title: 'SUPPLIER',
      dataIndex: ['order', 'supplier', 'name'],
      key: 'supplier',
      align: 'left',
      render: (_, record) => (
        <Paragraph style={{ margin: 0 }}>
          {record?.orders[0]?.supplier?.name ?? 'N/A'}
        </Paragraph>
      ),
    },
    {
      title: 'FACTORY',
      dataIndex: ['order', 'factory', 'name'],
      key: 'factory',
      align: 'left',

      render: (_, record) => (
        <Paragraph style={{ margin: 0 }}>
          {record?.orders[0]?.factory?.name ?? 'N/A'}
        </Paragraph>
      ),
    },
    {
      title: 'PLANNED DATE',
      dataIndex: 'planned_date',
      key: 'planned_date',

      filteredValue: stateFilter.planned_date,

      render: (date, record) => {
        const editable =
          enableEditRecord && [TO_PLAN, PLANNED].includes(record?.status)
        const isAllowAction = handleCheckPermission(user, record) && editable
        return date ? (
          <Space
            style={{ cursor: isAllowAction ? 'pointer' : '' }}
            onClick={() => {
              if (isAllowAction) {
                setInspection(record)

                record?.is_re_inspection
                  ? setEditReInspectionModal(true)
                  : setOpenNewInspection(true)
              }
            }}
          >
            <span>{moment(date).format('DD MMM YYYY')}</span>

            <Button
              type="link"
              style={{ cursor: isAllowAction ? 'auto' : 'unset' }}
              icon={
                <EditOutlined
                  style={{ visibility: isAllowAction ? 'visible' : 'hidden' }}
                />
              }
            />
          </Space>
        ) : (
          <a
            className="add-date-inspection"
            onClick={() => {
              setInspection(record)
              record?.is_re_inspection
                ? setEditReInspectionModal(true)
                : setOpenNewInspection(true)
            }}
          >
            <PlusOutlined style={{ marginRight: 4 }} />
            Add
          </a>
        )
      },
      align: 'left',
      filterIcon,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8, width: 250 }}>
          <DatePicker.RangePicker
            autoFocus
            onChange={(values) => {
              setDatesFilter(values)
            }}
            value={datesFilter ? [datesFilter[0], datesFilter[1]] : null}
            style={{ marginBottom: 8 }}
            format={INSPECTION_TEXT.dateFomat}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={() => {
                clearFilters()
                setDatesFilter(null)
              }}
              size="small"
              type="link"
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => {
                confirm()
                handleTableChange(
                  {},
                  {
                    ...stateFilter,
                    planned_date: datesFilter,
                  }
                )
              }}
              size="small"
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (!visible) {
          handleTableChange(
            {},
            {
              ...stateFilter,
              planned_date: datesFilter,
            }
          )
        }
      },
    },
    {
      title: 'INSPECTOR',
      dataIndex: 'inspector',
      key: 'inspectors',
      filters: userRole === USER_ROLE.ADMIN ? inspectors : null,
      filterIcon,
      filteredValue: stateFilter?.inspectors,
      render: (inspector, record) => {
        const firstName = inspector?.first_name ?? ''
        const lastName = inspector?.last_name ?? ''
        const fullname = `${firstName} ${
          lastName ? lastName.split('')[0] + '.' : ''
        }`
        const editable =
          enableEditRecord && [TO_PLAN, PLANNED].includes(record?.status)

        const isAllowAction = handleCheckPermission(user, record) && editable

        return inspector ? (
          <Space
            align="start"
            style={{ cursor: isAllowAction ? 'pointer' : '' }}
            onClick={() => {
              if (isAllowAction) {
                setInspection(record)
                record?.is_re_inspection
                  ? setEditReInspectionModal(true)
                  : setOpenNewInspection(true)
              }
            }}
          >
            <Space align="center">
              <Avatar
                size={32}
                icon={<UserOutlined />}
                src={inspector.avatar?.url_path}
              />
              <span>{fullname}</span>
            </Space>

            <Button
              type="link"
              style={{ cursor: isAllowAction ? 'auto' : 'unset' }}
              icon={
                <EditOutlined
                  style={{ visibility: isAllowAction ? 'visible' : 'hidden' }}
                />
              }
            />
          </Space>
        ) : (
          <a
            className="underline"
            onClick={() => {
              setInspection(record)
              record?.is_re_inspection
                ? setEditReInspectionModal(true)
                : setOpenNewInspection(true)
            }}
            style={{ color: '#ef9747' }}
          >
            <PlusOutlined style={{ marginRight: 4 }} />
            Add
          </a>
        )
      },
      align: 'left',
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      filterIcon,
      filteredValue: stateFilter?.status,
      render: (status) => {
        let bgColor = '#848484'

        switch (status) {
          case TO_PLAN:
            bgColor = '#C03261'
            break
          case PLANNED:
            bgColor = '#4A8DC0'
            break
          case IN_PROGRESS:
            bgColor = '#EF9747'
            break
          case SUBMITTED:
          case REVIEWED:
          case APPROVED:
            bgColor = '#65BF73'
            break
          case UNDER_REVIEW:
            bgColor = '#EF9747'
            break
          case NEEDS_REVISIONS:
            bgColor = '#C03261'
            break
          default:
            break
        }

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                height: 12,
                width: 12,
                paddingRight: 12,
                borderRadius: '50%',
                backgroundColor: bgColor,
              }}
            />
            <span style={{ marginLeft: 8 }}>
              {startCase(lowerCase(status.replace('_', ' ')))}
            </span>
          </div>
        )
      },
      filters: filterOptionsStatus,
    },
    {
      title: 'RESULT',
      dataIndex: 'result',
      key: 'result',
      filters: filterOptionsResult,
      filterIcon,
      filteredValue: stateFilter.result,
      render: (result: InspectionResult, record: any) => {
        const lowerResult = (result || '').toString().toLowerCase()
        const dynamicResult = find(
          overallResultSetting,
          (item: any) =>
            item.value?.toLowerCase() === lowerResult ||
            item.name?.toLowerCase() === lowerResult
        )

        let color = dynamicResult?.color ?? ''

        if (!dynamicResult && !isEmptyValue(result)) {
          const customOptions =
            record?.template?.option?.overall_result?.custom?.options || []
          const fromTemplate = customOptions.find(
            (opt: any) =>
              opt.name?.toLowerCase() === lowerResult ||
              opt.value?.toLowerCase() === lowerResult
          )
          if (fromTemplate) {
            color = fromTemplate.color
          }
        }

        return (
          <span
            style={{
              textAlign: 'center',
              color: color,
              fontWeight: '600',
            }}
          >
            {result === InspectionResult.NA
              ? 'N/A'
              : !isEmptyValue(result)
              ? result
              : '-'}
          </span>
        )
      },
    },
    {
      title: 'SUBMITTED DATE',
      dataIndex: 'finish_date',
      key: 'submitted_date',
      filteredValue: stateFilter.submitted_date,

      render: (date, record) => {
        const editable =
          enableEditRecord && [TO_PLAN, PLANNED].includes(record?.status)
        const isAllowAction = handleCheckPermission(user, record) && editable
        return date ? (
          <Space
            style={{ cursor: isAllowAction ? 'pointer' : '' }}
            onClick={() => {
              if (isAllowAction) {
                setInspection(record)

                record?.is_re_inspection
                  ? setEditReInspectionModal(true)
                  : setOpenNewInspection(true)
              }
            }}
          >
            <span>{moment(date).format('DD MMM YYYY')}</span>

            <Button
              type="link"
              style={{ cursor: isAllowAction ? 'auto' : 'unset' }}
              icon={
                <EditOutlined
                  style={{ visibility: isAllowAction ? 'visible' : 'hidden' }}
                />
              }
            />
          </Space>
        ) : (
          <p>-</p>
        )
      },
      align: 'left',
      filterIcon,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8, width: 250 }}>
          <DatePicker.RangePicker
            autoFocus
            onChange={(values) => setSubmitDateFilter(values)}
            value={
              submitDateFilter
                ? [submitDateFilter[0], submitDateFilter[1]]
                : null
            }
            style={{ marginBottom: 8 }}
            format={INSPECTION_TEXT.dateFomat}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={() => {
                clearFilters()
                setSubmitDateFilter(null)
              }}
              size="small"
              type="link"
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => {
                confirm()
                handleTableChange(
                  {},
                  {
                    ...stateFilter,
                    submitted_date: submitDateFilter,
                  }
                )
              }}
              size="small"
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (!visible) {
          handleTableChange(
            {},
            {
              ...stateFilter,
              submitted_date: submitDateFilter,
            }
          )
        }
      },
    },
    {
      title: 'ORDER NO.',
      dataIndex: ['order', 'number'],
      key: 'orderNumber',
      render: (_, record) => {
        const orderNumbers = record?.orders?.map((item) => item?.number) ?? []
        if (isEmptyValue(orderNumbers)) {
          return (
            <Paragraph style={{ margin: 0 }}>
              {record?.order?.number ?? 'N/A'}
            </Paragraph>
          )
        }
        return <MultiValueOverflow items={orderNumbers} title="Order no." />
      },
    },
    {
      title: 'Style no.',
      dataIndex: 'pv_style_id_str',
      key: 'styleNo',
      align: 'left',
      render: (value) => {
        const styleNumbers = isString(value)
          ? value.split(',').map((item) => item.trim())
          : []
        return <MultiValueOverflow items={styleNumbers} title="Style no." />
      },
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      render: (_, record) => {
        const isAllowAction = handleCheckPermission(user, record)
        const isReviewReport = handleStatusToReviewReport(record.status)
        const isDeleteEnable = deleteFeatureEnabled(user, record)
        const statusToReCreate = handleStatusToReCreate(record.status)
        // Allow to Re-Inspection with Single PO
        const isOrderLength1 = record?.orders?.length < 2
        // Check the inspection has already Re-Inspection
        const isEmptyReInspection = isEmptyValue(record?.re_inspections)
        // Verify that the inspection is not a re-inspection
        const isNotAsReInspection = !record?.is_re_inspection
        const inspector = get(record, 'inspector')
        // Enable Re-Inspection when performance by admin or inspection owner
        const isOwnInspection = inspector?.id === user?.id || isAdmin

        const items: MenuProps['items'] | any = [
          [TO_PLAN, PLANNED].includes(record.status) &&
            isAllowAction && {
              label: 'Edit',
              key: 'edit',
              icon: <EditOutlined />,
              onClick: () => {
                setInspection(record)
                record?.is_re_inspection
                  ? setEditReInspectionModal(true)
                  : setOpenNewInspection(true)
              },
            },
          isReviewReport && {
            label: 'Report',
            key: 'report',
            icon: <FilePdfOutlined />,
            onClick: () => navigation(`/qsf/report/${record.id}`),
          },
          activeTile !== InspectionGroupStatus.ACTIVE &&
            statusToReCreate &&
            enableEditRecord &&
            isEmptyReInspection &&
            isNotAsReInspection &&
            isOrderLength1 &&
            isOwnInspection && {
              label: 'Re-inspection',
              key: 'Re-Inspection',
              icon: <RetweetOutlined />,
              onClick: () => {
                setInspection(record)
                setReInspectionModal(true)
              },
            },
          isDeleteEnable && {
            label: 'Delete',
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: () => {
              setInspection(record)
              setModalDelete(true)
            },
          },
        ]
        return (
          <Dropdown
            trigger={['click']}
            menu={{ items }}
            disabled={
              items[0] === false &&
              items[1] === false &&
              items[2] === false &&
              items[3] === false
            }
          >
            <Button className="button-more">
              <MoreOutlined />
            </Button>
          </Dropdown>
        )
      },
    },
  ]

  const { Search } = Input
  const navigate = useNavigate()

  const onOpenCloseAdvanceFilterFN = () => {
    setIsOpenAdvanceFilter(!isOpenAdvanceFilter)
  }
  const onSearch = debounce((event) => {
    const seachValue = isString(event) ? event : event.target.value
    onSetPage(1)
    handleTableChange({}, { ...stateFilter, query: seachValue })
  }, 500)

  const handleSetSupplier = (supplierData) => {
    setModalInspectionData((prevState) => ({
      ...prevState,
      supplierData,
    }))
  }

  const handleSetFactories = (factoriesData) => {
    setModalInspectionData((prevState) => ({
      ...prevState,
      factoriesData,
    }))
  }

  const handleSetStateSubmitForReview = (dataSetting: any) => {
    const checkIsActive = find(dataSetting, {
      status: 'active',
      name: COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW,
    })

    if (checkIsActive) {
      setStateSubmitForReview(checkIsActive)
    }
  }

  const handleEnableEditRecord = (
    hasInspectorSetting: boolean,
    hasSupplierSetting: boolean
  ) => {
    // CHECK COMPANY SETTING FOR INSPECTOR
    if (userRole === USER_ROLE.INSPECTOR) {
      setEnableEditRecord(hasInspectorSetting)
    }
    // CHECK COMPANY SETTING FOR SUPPLIER
    if (userRole === USER_ROLE.SUPPLIER) {
      setEnableEditRecord(hasSupplierSetting)
    }
  }
  const splitFN = (key) =>
    getUrlParams(key) ? getUrlParams(key).split(',') : null
  // TODO: handle status depend on Tile, currently there is an issues in Drawer when change the tile
  // TODO: Load page with query params need to handle
  const handleFilterParamsUrl = () => {
    const paramKeys = [
      'status',
      'planned_date',
      'result',
      'inspectors',
      'submitted_date',
      'countries',
      'inspection_type_ids',
      'suppliers',
      'factories',
      'style_ids',
      'order_ids',
      'brands',
      'query',
    ]

    const params = paramKeys.reduce((acc, key) => {
      let value: any = splitFN(key)
      if (key === 'query') value = value?.toString() || null
      acc[key] = value
      return acc
    }, {} as Record<string, any>)

    if (params.planned_date) {
      setDatesFilter(transformFromUrlQueryToDateRange(params.planned_date))
    }
    if (params.submitted_date) {
      setSubmitDateFilter(
        transformFromUrlQueryToDateRange(params.submitted_date)
      )
    }

    handleTableChange(
      {},
      params as INSPECTION_PARAMS_TYPE & INSPECTION_PAYLOAD_TYPE
    )
  }

  // = = = = = Handle function zone = = = = =

  const adminFetchData = async () => {
    if (isAdmin || isInspRole) {
      const companyId = user?.company?.id
      const [supplierData] = await Promise.all([
        getSupplierRef(
          {
            companyId,
            pickField: ['id', 'name', 'factories'],
          },
          isAdmin || isInspRole
        ),
      ])
      handleSetSupplier(supplierData)
    }
  }

  const handleFetchData = async () => {
    const settingName = COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW
    const [hasInspectorSetting, hasSupplierCanCreateSetting, hasCompanySubmitForReview] =
      await Promise.all([
        getInspectorSetting(),
        getSupplierCanCreateInspectionSetting(),
        getCompanySettingRef('', settingName),
      ])
    await adminFetchData()
    handleEnableEditRecord(hasInspectorSetting, hasSupplierCanCreateSetting)
    handleSetStateSubmitForReview(hasCompanySubmitForReview)
    handleFilterParamsUrl()
  }

  const handleFetchDataSetAdvanceFilter = async () => {
    const companyId = user?.company?.id

    const [factoriesData, countryData, getInspectionType, getInspectionBrand] =
      await Promise.all([
        getFactoriesRef(
          {
            companyId,
            pickField: ['id', 'name', 'factories'],
          },
          isAdmin
        ),
        getCountryByFactory({ companyId, type: 'factory' }, isAdmin),
        getPropertyValueInspectionType(),
        getPropertyValueInspectionBrand(),
      ])

    handleSetFactories(factoriesData)
    setCountryFactory(countryData)
    setInspectionType(getInspectionType)
    setInspectionBrand(getInspectionBrand)
  }

  const handleSetupFilterOptionStatus = () => {
    let statusOptions = []
    if (activeTile === ALL) {
      statusOptions = filterOptionsForAll
    } else if (activeTile === COMPLETED) {
      statusOptions = filterOptionsForSubmitted
    } else {
      statusOptions = filterOptionsForActive
    }

    if (stateSubmitForReview) {
      const { key, value } = extraFilterOptionsBy[stateSubmitForReview?.name]

      if (includes(key, activeTile)) {
        statusOptions = concat(statusOptions, value)
      }
    }

    setFilterOptionsStatus(statusOptions)
  }

  // = = = = = useEffect Zone = = = = =
  useEffect(() => {
    handleFetchData()
  }, [])

  useEffect(() => {
    if (isOpenAdvanceFilter) {
      handleFetchDataSetAdvanceFilter()
    }
  }, [isOpenAdvanceFilter])

  useEffect(() => {
    handleSetupFilterOptionStatus()
    handleSetStateParams({ group: activeTile || ACTIVE })
    onSetPage(1)
  }, [activeTile, stateSubmitForReview])

  const onSetPage = (page) => {
    navigate({
      search: `?${setUrlParams('page', page)}`,
    })
    handleSetStateParams({ page_number: page })
  }
  const onSetPageSize = (size) => {
    handleSetStateParams({ page_size: size })
    storeLocalInspectionPageSize(size)
  }

  const onDelete = async () => {
    await deleteMutation.mutateAsync()
    setModalDelete(false)
    await refetch()
    await queryClient.invalidateQueries([
      InspectionConstant.QUERY_KEY.INSPECTIONS_ADVANCE_SUMMARY,
    ])
    setInspection(null)
  }

  const handleOnSubmitFilter = (dataFilter) => {
    handleTableChange({}, dataFilter)
  }

  const getOrderNumbers = inspection?.orders
    .map((elem) => elem.number)
    .join(', ')

  const getDeleteContent = () => {
    const inspectionNumber = <strong>{inspection?.number}</strong>
    const orderNumbers = `(order no. ${getOrderNumbers})`
    if (inspection.status === 'PLANNED') {
      return (
        <span>
          Are you sure you want to delete the inspection no. {inspectionNumber}?{' '}
          {orderNumbers}
          <br />
          <br />
          The assigned inspector will be notified and you won’t be able to
          access it anymore
        </span>
      )
    }
    return (
      <div>
        Are you sure you want to delete the inspection no. {inspectionNumber}?{' '}
        {orderNumbers}.
        <br />
        You won’t be able to access it anymore.
      </div>
    )
  }

  return (
    <div>
      <Row
        className="inspection-table-toolbar"
        justify="space-between"
        align="middle"
      >
        <Col className="inspection-table-filters">
          <Search
            className="inspection-search-container"
            placeholder={INSPECTION_TEXT.searchInspection}
            size="large"
            defaultValue={tmpSearch} // support only default value
            onChange={onSearch}
          />
          {/* tmp enable advance filter for Admin role only  */}
          {isAdmin && (
            <>
              <Button
                className={`button-advance-filter ${
                  isEmptyFiltering && 'grey-bg'
                }`}
                size="large"
                type="primary"
                icon={filterIcon}
                onClick={onOpenCloseAdvanceFilterFN}
              />
              <Button
                className="button-clear-filter"
                disabled={isEmptyFiltering}
                type="link"
                icon={undoIcon}
                onClick={() => {
                  setTmpSearch('')
                  handleResetFilter()
                }}
              >
                Clear
              </Button>
            </>
          )}
        </Col>
        {enableEditRecord && (
          <Col className="inspection-table-actions">
            <Button
              className="loadmore-button"
              size="large"
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setOpenNewInspection(true)}
            >
              New Inspection
            </Button>
          </Col>
        )}
      </Row>
      <div className={'list-inspection-container'}>
        <Table
          className="list-inspection-table table-container"
          sticky
          rowKey="id"
          loading={isLoading || isFetching}
          columns={columns}
          dataSource={queryInspections?.data}
          onChange={handleTableChange}
          scroll={{ x: 'max-content' }}
          tableLayout="auto"
          pagination={{
            pageSize: Number(stateParams.page_size),
            current: Number(stateParams.page_number),
            total: queryInspections?.pagination?.total_record,
            onChange: (page, pageSize) => {
              onSetPage(page)
              onSetPageSize(pageSize)
            },
            showSizeChanger: true,
            showLessItems: true,
          }}
        />
      </div>
      {openNewInspection && (
        <ModalNewInspection
          userRole={userRole}
          inspection={inspection}
          visible={openNewInspection}
          onClose={() => {
            setInspection(null)
            setOpenNewInspection(false)
          }}
          dataSource={propertiesData ?? []}
          isFetched={isFetchedProperties}
          isLoading={isLoadingProperties}
        />
      )}
      {reInspectionModal && (
        <ModalReInspection
          userRole={userRole}
          inspection={inspection}
          visible={reInspectionModal}
          onFinish={noop}
          onClose={() => {
            setInspection(null)
            setReInspectionModal(false)
          }}
        />
      )}
      {editReInspectionModal && (
        <ModalEditReInspection
          userRole={userRole}
          inspection={inspection}
          visible={editReInspectionModal}
          onFinish={noop}
          onClose={() => {
            setInspection(null)
            setEditReInspectionModal(false)
          }}
        />
      )}
      {modalDelete && (
        <ModalConfirm
          onOK={onDelete}
          loading={deleteMutation.isLoading}
          confirmButtonText="Yes, Delete"
          cancelButtonText="No, Cancel"
          title="Delete Inspection"
          type="delete"
          content={<div>{getDeleteContent()}</div>}
          open={modalDelete}
          onClose={() => {
            setModalDelete(false)
          }}
        />
      )}
      {deleteMutation.isLoading && <LoadingComponent />}
      {/* tmp enable advance filter for Admin role only  */}
      {isAdmin && isOpenAdvanceFilter && (
        <DrawerAdvanceFilter
          isOpen={isOpenAdvanceFilter}
          onClose={onOpenCloseAdvanceFilterFN}
          dataSource={{
            inspectors,
            statuses: filterOptionsStatus,
            result: filterOptionsResult,
            country: countryFactory,
            inspectionType: inspectionType,
            inspectionBrand: inspectionBrand,
            supplier: modalInspectionData?.supplierData,
            factories: modalInspectionData?.factoriesData,
            style_ids: styleIdsOptions,
          }}
          dataFilter={pick(stateFilter, INSPECTION_ADVANCE_FILTER_LISTING)} // Listing item by ordering
          onSubmit={handleOnSubmitFilter}
          drawerMode="myQuality"
        />
      )}
    </div>
  )
}
